// removed by extract-text-webpack-plugin
module.exports = {"footerWrap":"_3Eo6ZuZevVDQ7c8L5DDrGX","footerList":"_3jVBRZB38Do2eIjK3DAAYF"};


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/scss/components/footer.scss
// module id = 186
// module chunks = 0